/* Small product-state helpers shared by the storefront and regression checks. */
(() => {
  'use strict';
  function namespace(root,prefix){
    const ids=new Map();
    root.querySelectorAll('[id]').forEach(el=>{const old=el.getAttribute('id'),next=prefix+old;el.setAttribute('id',next);ids.set(old,next);});
    root.querySelectorAll('[for],[form],[aria-controls],[aria-labelledby],[aria-describedby],[data-open-dialog]').forEach(el=>{
      for(const attr of ['for','form','aria-controls','aria-labelledby','aria-describedby','data-open-dialog'])if(el.hasAttribute(attr))el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));
    });
  }
  function fields(root){const form=root.querySelector('[data-product-form]');return form?[...form.elements].filter(el=>/^(quantity|selling_plan|properties\[)/.test(el.name||'')):[];}
  function snapshot(root){return fields(root).map(el=>({name:el.name,value:el.value,checked:el.checked,type:el.type}));}
  function quantity(value,min,step,max){const bounded=Math.max(min,Math.min(Number(value)||min,max));return min+Math.floor((bounded-min)/step)*step;}
  function restore(root,values){
    fields(root).forEach(el=>{
      const old=values.find(v=>v.name===el.name&&v.type===el.type);if(!old)return;
      if(el.name==='quantity'&&el.type==='hidden')return;
      if(el.name==='quantity')el.value=quantity(old.value,Number(el.min||1),Number(el.step||1),el.max?Number(el.max):Infinity);
      else if(el.tagName!=='SELECT'||[...el.options].some(option=>option.value===old.value))el.value=old.value;
      if(['checkbox','radio'].includes(el.type))el.checked=old.checked;
    });
  }
  function scheduled(start,end,minutes){
    const parse=value=>/^([01]\d|2[0-3]):[0-5]\d$/.test(value||'')?Number(value.slice(0,2))*60+Number(value.slice(3)):null;
    const a=parse(start),b=parse(end);return a===null||b===null||a===b||(a<b?minutes>=a&&minutes<b:minutes>=a||minutes<b);
  }
  const api={namespace,fields,snapshot,restore,quantity,scheduled};
  if(typeof module==='object'&&module.exports)module.exports=api;else window.PawProductCore=api;
})();
